export * from "./enums.js";
export * from "./study.js";
export * from "./participant.js";
export * from "./analysis.js";
export * from "./auth.js";
export * from "./video.js";
export * from "./demo.js";

export const API_PREFIX = "/api/v1";
